export default __webpack_public_path__ + "static/cookie-e0df5e0e66662584a305a03bcaa2f5e0.svg";